import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=c5d6c684&scoped=true"
import script from "./HomeAbout.vue?vue&type=script&lang=ts"
export * from "./HomeAbout.vue?vue&type=script&lang=ts"
import style0 from "./HomeAbout.vue?vue&type=style&index=0&id=c5d6c684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d6c684",
  null
  
)

export default component.exports